<template>
  <div class="page-box">
    <van-overlay class="box-center" :show="dialogLoading">
      <van-loading type="spinner" size="40px" vertical>正在核验中...</van-loading>
    </van-overlay>
    <step :index="1"></step>
    <div v-if="form.reportUrl">
      <div class="photo-box">
        <img class="photo-img" :src="form.reportUrl" width="100%" alt="" @click="onImagePreview(form.originUrl)"/>
      </div>
      <ul class="step-ul">
        <li class="li">
          1.背景须为纯白色(如垫A4纸)，确保证件摆放端正；
        </li>
        <li class="li">
          2.证件拍摄件应干净、字迹清晰，避免出现模糊、反光等影响识别的图片；
        </li>
        <li class="li">
          3.只能使用原件拍摄，不允许使用复印件或屏幕翻拍。
        </li>
      </ul>
      <div class="photo-info">
        <div class="info-title">确认主体负责人信息</div>
        <div class="info-msg">若信息有误请重新拍摄识别，若信息正确请确认信息</div>
      </div>
      <div class="form-box">
        <div class="item">
          <div class="label">姓名</div>
          <input class="value" v-model.trim="form.name" placeholder="请填写姓名">
        </div>
        <div class="item">
          <div class="label">证件号</div>
          <input class="value" v-model.trim="form.idCard" placeholder="请填写证件号">
        </div>
      </div>
      <div class="button-box">
        <van-uploader class="btn" :before-read="onBeforeRead" :after-read="onAfterRead">
          <van-button type="primary" class="btn" accept="image/*">重新上传</van-button>
        </van-uploader>
        <div class="margin-r20"></div>
        <van-button type="primary" class="btn" @click.prevent="onSubmit">确认信息</van-button>
      </div>
    </div>
    <div v-else>
      <div class="camera-box">
        <img class="camera-icon" src="@/assets/img/filing/camera.png" alt="">
        <div class="camera-msg">请拍摄主体负责人{{$store.getters["filingStore/getInfo"]['accountFzrXm']}}的身份证（人像面）</div>
      </div>
      <ul class="step-ul">
        <li class="li">
          1.背景须为纯白色(如垫A4纸)，确保证件摆放端正；
        </li>
        <li class="li">
          2.证件拍摄件应干净、字迹清晰，避免出现模糊、反光等影响识别的图片；
        </li>
        <li class="li">
          3.只能使用原件拍摄，不允许使用复印件或屏幕翻拍。
        </li>
      </ul>
      <van-uploader class="button-box" :before-read="onBeforeRead" :after-read="onAfterRead">
        <van-button type="primary" class="btn" accept="image/*">上传照片</van-button>
      </van-uploader>
    </div>
  </div>
</template>
<script>
import {ImagePreview} from 'vant';
import Step from '../components/Step.vue'
export default {
  components:{
    Step,
  },
  data() {
    return {
      dialogLoading:false,
      form:{
        expire: '', 
        idCard: '', 
        name: '', 
        originUrl: '', 
        reportUrl: '', 
        rotateUrl: '', 
      }
    };
  },
  methods: {
    //上传前限制图片：返回布尔值
    onBeforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$dialog.alert({
          message: '请上传图片',
          confirmButtonColor:'#4285f5',
        });
        return false;
      }
      return true;
    },
    //上传后：识别图片信息
    onAfterRead(res){
      this.dialogLoading = true;
      this.$apis.filingServer.uploadFile({
        uploadType:71,
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
        file:res.file,
      }).then(res=>{
        if (res['code'] == 0) {
          this.getPersonInfo(res['data']['originUrl'],res['data']['reportUrl']);
        } else {
          this.dialogLoading = false;
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    //获取证件信息
    getPersonInfo(originUrl,reportUrl){
      this.$apis.filingServer.getPersonInfo({
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
        reportUrl,
        legalPerson:localStorage.getItem('legalPerson'),
        type:1,//1 正面 2 反面
      }).then(res=>{
        this.dialogLoading = false;
        if (res['code'] == 0) {
          if(res['data']['idCard'] && res['data']['name']){
            this.form.originUrl=originUrl, 
            this.form.reportUrl=reportUrl, 
            Object.assign(this.form,res['data']);
          }else{
            this.$dialog.alert({
              message: '证件图片核验未通过，请重新上传',
              confirmButtonColor:'#4285f5',
            });
          }
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    onImagePreview (url) {
      ImagePreview([ url ]);
    },
    onSubmit(){
      this.dialogLoading = true;
      const query = this.$route.query
      this.$apis.filingServer.verifyPersonFrontInfo({
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
        ...this.form,
        type:1,//1 主体负责人 2 快应用负责人
      }).then(res=>{
        this.dialogLoading = false;
        if (res["code"] == 0) {
          if(res["data"]){
            this.$router.push({ path: '/filing/process/organizer/fzrXm2', query });
          }else{
            this.$dialog.alert({
              message: '您的主办单位负责人信息与之前填写的不一致，请核对信息后重新填写。',
              confirmButtonColor:'#4285f5',
            });
          }
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .title-box{
    display: flex;
    align-items: center;
    .title{
      font-size: 30px;
      font-weight: bold;
    }
    .time{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 24px;
      color: #333;
      /deep/ .van-count-down{
        color: #333;
        font-size: 24px;
      }
    }
  }
  .camera-box{
    margin: auto;
    margin-top: 40px;
    padding: 50px;
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 10px;
    .camera-icon{
      display: block;
      margin: auto;
      width: 250px;
    }
    .camera-msg{
      text-align: center;
      color: #ccc;
    }
  }
  .photo-box{
    margin-top: 40px;
  }
  .step-ul{
    margin-top: 20px;
    color: #ccc;
    .li{
      line-height: 38px;
    }
  }
  .photo-info{
    margin-top: 40px;
    .info-title{
      font-size: 28px;
      font-weight: bold;
    }
    .info-msg{
      margin-top: 20px;
      margin-bottom: 50px;
      font-size: 26px;
      color: #ccc;
    }
  }
  .form-box{
    margin-top: 30px ;
    .value{
      margin: 20px 0;
      width: 100%;
      padding: 10px;
    }
  }
  .button-box{
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .btn{
      flex: 1;
      display: flex;
      justify-content: center;
      background-color: #4285f5;
      border-color: #4285f5;
      border-radius: 10px;
    }
  }
}
</style>
